import { MonitorType } from '../../../types/monitor/MonitorType';
import { AdminMonitorStatsResponse } from '../../../models/admin/dashboard/AdminMonitorStatsResponse';
import type {
  AdminAccountStatusChange,
  AdminUserCountChangesResponse,
  AdminWorkerRuntimeConfig,
} from '@brand24-original/llm-types';
import { client } from '../../apiClient';
import { AdminConfigurationResponse } from '../../../models/admin/dashboard/AdminConfigurationResponse';

export interface BlockedIp {
  id: number;
  ip: string;
  reason: string | null;
  createdAt: string;
}

export const getConfiguration = async (): Promise<AdminConfigurationResponse[]> => {
  return client(true, true)
    .get<AdminConfigurationResponse[]>(`/admin/dashboard/configuration`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getActiveMonitorStats = async (): Promise<number> => {
  return client(true, true)
    .get<number>(`/admin/dashboard/monitors`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getActiveUsersStats = async (): Promise<{
  disabled: number;
  blocked: number;
  trial: number;
  paid: number;
  unpaid: number;
}> => {
  return client(true, true)
    .get<{
      disabled: number;
      blocked: number;
      trial: number;
      paid: number;
      unpaid: number;
    }>(`/admin/dashboard/users`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getUserCountChanges = async (): Promise<AdminUserCountChangesResponse> => {
  return client(true, true)
    .get<AdminUserCountChangesResponse>('/admin/dashboard/users/changes')
    .then((response) => response.data)
    .catch((error) => error);
};

export const getWorkerRuntimeConfigs = async (): Promise<AdminWorkerRuntimeConfig[]> => {
  return client(true, true)
    .get<AdminWorkerRuntimeConfig[]>('/admin/dashboard/worker-config')
    .then((response) => response.data)
    .catch((error) => error);
};

export const getDailyRequestStats = async (date?: string): Promise<AdminMonitorStatsResponse[]> => {
  const params = date ? `?date=${date}` : '';
  return client(true, true)
    .get<AdminMonitorStatsResponse[]>(`/admin/dashboard/${params}`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getAccountStatusChanges = async (date: string): Promise<AdminAccountStatusChange[]> => {
  return client(true, true)
    .get<AdminAccountStatusChange[]>(`/admin/dashboard/status-changes?date=${date}`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getBlockedIps = async (): Promise<BlockedIp[]> => {
  return client(true, true)
    .get<BlockedIp[]>('/admin/dashboard/blocked-ips')
    .then((response) => response.data);
};

export const addBlockedIp = async (ip: string, reason: string | null): Promise<BlockedIp> => {
  return client(true, true)
    .post<BlockedIp>('/admin/dashboard/blocked-ips', { ip, reason })
    .then((response) => response.data);
};

export const removeBlockedIp = async (id: number): Promise<void> => {
  await client(true, true).delete(`/admin/dashboard/blocked-ips/${id}`);
};

export const toggleConfiguration = async (
  feature: string,
  isEnabled: boolean
): Promise<AdminConfigurationResponse> => {
  return client(true, true)
    .put<AdminConfigurationResponse>(`/admin/dashboard/configuration/${feature}`, { isEnabled })
    .then((response) => response.data);
};
